<template>
  <div>
    <h1>Depositing to WSB</h1>
    <button class="btn-back" @click="backmenu">
      <img src="/icons/back.png" alt="Back" class="arrow-icon" />
      Back to Deposit Menu
    </button>
    <p>
      You can deposit money on your wallet. It’s Easy!<br>
      <img src="/icons/visa-master.png"  alt="nedbank Logo" style="height: 20px; vertical-align: middle; margin-right: 5px;">
       Debit/Credit Card Deposit.<br>
      Hello user: <a>{{ username }}</a>
    </p>

    <!-- Mostrar el contenedor solo si no se ha enviado el depósito -->
    <div v-if="showDepositForm" class="contenedor">
      <p>Please click on the amount you would like to deposit
      OR
      Please enter the amount in the box below</p>
     <!-- Botones de selección de cantidad -->
     <div class="amount-buttons">
        <button v-for="amt in amounts" :key="amt" :disabled="isLoading" @click="setAmount(amt)">
          {{ amt.toLocaleString() }} LSL
        </button>
      </div>
      
      <span>Amount</span>
      <div class="amount">
        <button class="button">LSL</button>
        <input type="number" v-model="amount" min="1" step="1" @input="validateAmount">
      </div>
      <div v-if="showError" class="mensaje-error">Min: 1 LSL</div>
      <div v-if="showErrorD" class="mensaje-error">Only 2 decimal places are allowed.</div>
      
      <!-- Mostrar el botón de depósito o el spinner si se está procesando -->
      <button class="deposit" @click="submitDeposit" :disabled="isLoading">
        <span v-if="isLoading">Processing...</span>
        <span v-else  style="color:black">Deposit</span>
      </button>
    </div>

    <!-- Mostrar el mensaje de éxito o error en la pantalla -->
    <div v-if="responseMessage" class="response-message" :class="responseType">
      <p v-html="responseMessage"></p>
    </div>

    <div class="finaltext">
      <p>
        After completing the above steps, your deposit will appear on your wsbetting.co.ls account.
        Please allow a few seconds for this to happen.<br>
        <a>Note</a>: Make sure any pop-up blocker is disabled.
      </p>
    </div>
  </div>

</template>

<script>
import nedbankservice from '@/scripts/apiServiceNedbank.js';
import common from '@/scripts/common.js';

export default {
  
  data() {
    return {
      username: this.$route.query.username || "Unknown User", // Obtener el parámetro de la URL
      amount: null,
      showError: false,
      showErrorD: false,
      responseMessage: "",  // Mensaje de la respuesta
      responseType: "",     // Tipo de mensaje (exito / error)
      showDepositForm: true, // Controla la visibilidad del formulario de depósito
      isLoading: false,      // Controla si la solicitud está en proceso
      amounts: [1,2,5, 10, 20, 30, 50, 100, 200, 300, 500, 700, 1000],
      showLiteboxForm: false, // Controla la visibilidad del LiteboxForm
      formData: {
        wsb_original_amount: "0",
        Lite_Merchant_ApplicationID: "",
        Ecom_BillTo_Online_Email:  "cliente@ejemplo.com",
        Lite_Order_Amount:  "0",
        Lite_ConsumerOrderID_PreFix: "INV",
        Lite_Order_LineItems_Quantity_1: "1",
        Lite_Order_LineItems_Amount_1: "0",
        Ecom_ConsumerOrderID: "-",
        Ecom_Payment_Card_Protocols: "IVERI",
        Ecom_TransactionComplete: "False",
        Lite_Currency_AlphaCode: "ZAR",
        Lite_Version: "4.0",
      } , //
    };
  },
  methods: {
     backmenu() {
      this.$router.push({ name: 'DepositWebsiteLesotho' , query: { username: this.$route.query.username }  });
    },
    redirectContact() {
      window.parent.postMessage({ action: 'btncontact' }, '*');
    },
    redirigirPorPost() {
    const apiUrl = process.env.VUE_APP_API_URL_NEDBANK_RESPONSE;
    const websiteurl = window.location.origin; //process.env.VUE_APP_WEBSITE_NEDBANK;
  
    window.parent.postMessage({ action: 'payment_initiated' }, '*');
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = 'https://portal.nedsecure.co.za/Lite/Authorise.aspx';
    form.target = '_self'; // o '_blank' si quieres abrir en nueva pestaña

    // Parámetros a enviar
    const params = {
        wsb_original_amount: this.formData.wsb_original_amount,
        url_wsb_return: websiteurl+"/#/NedbankDepositResponse?username=" + this.username,
        Lite_Merchant_ApplicationID: this.formData.Lite_Merchant_ApplicationID,
        Ecom_BillTo_Online_Email:  "carlosjuliows@gmail.com",
        Lite_Order_Amount:  this.formData.Lite_Order_Amount,
        Lite_ConsumerOrderID_PreFix: "INV",
        Lite_Website_Successful_Url: apiUrl + "/api/nedbank/responseNedbank",
        Lite_Website_Fail_Url: apiUrl + "/api/nedbank/responseNedbank",
        Lite_Website_TryLater_Url: apiUrl + "/api/nedbank/responseNedbank",
        Lite_Website_Error_Url: apiUrl + "/api/nedbank/responseNedbank",
        Lite_Order_LineItems_Product_1: "Instant Deposit lesotho",
        Lite_Order_LineItems_Quantity_1: "1",
        Lite_Order_LineItems_Amount_1: this.formData.Lite_Order_LineItems_Amount_1,
        Ecom_ConsumerOrderID: this.formData.Ecom_ConsumerOrderID,
        Ecom_Payment_Card_Protocols: "IVERI",
        Lite_Return_Url_Success: apiUrl + "/api/nedbank/responseNedbank",
        Lite_Return_Url_Cancel: apiUrl + "/api/nedbank/responseNedbank",
        Ecom_TransactionComplete: "False",
        Lite_Currency_AlphaCode: "ZAR",
        Lite_Version: "4.0",
    };

    // Agregar inputs al formulario
    for (const key in params) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = params[key];
      form.appendChild(input);
    }

    // Añadir el formulario al DOM y enviarlo
    document.body.appendChild(form);
    form.submit();
  },
    validateAmount() {
      this.showError = this.amount !== null && this.amount < 1;
      if (!this.showError) 
        this.showErrorD = this.amount.toString().split(".")[1] && this.amount.toString().split(".")[1].length > 2
    },
    async setAmount(value) {
      this.amount = value;
      this.showError = false;
      this.showErrorD = false;
       await this.submitDeposit();
    },
    validatetwoDecimals() {
              // Chequear si tiene más de 2 decimales
        const decimalPart = this.amount.toString().split(".")[1];
        const hasMoreThanTwoDecimals = decimalPart && decimalPart.length > 2;
        // Mostrar error si alguna de las condiciones es verdadera
         return hasMoreThanTwoDecimals;
    },
    async submitDeposit() {
      if (this.amount < 1) {
        this.responseMessage = "Amount must be at least 1 LSL.";
        this.responseType = "error";  // Tipo error
        return;
      }

      if (this.validatetwoDecimals()) {
        this.showErrorD = true;
        return;
      }



      let amount = this.amount.toString();
      this.formData.wsb_original_amount = amount; // Asignar el monto original a formData
      
      // Verificar si amount tiene un punto decimal
      if (amount && amount.includes(".")) {
        // Separar la parte entera y decimal
        let [integer, decimal] = amount.split(".");

        // Asegurarse de que la parte decimal tenga exactamente dos dígitos
        decimal = decimal.length === 1 ? decimal + "0" : decimal;

        // Concatenar la parte entera con los dos dígitos decimales
        amount = integer + decimal;
      } else {
        // Si no tiene punto decimal, agregar ".00"
        amount = amount + "00";
      }
      
      this.formData.Lite_Order_LineItems_Amount_1 = amount ;
      this.formData.Lite_Order_Amount = amount ;
 this.isLoading = true;
      // Llamar al backend para obtener datos
  const response = await nedbankservice.createDeposit({ appkey: "" , username: this.$route.query.username , amount: this.formData.wsb_original_amount });
     
    if (response.success) {
      //console.log("litebox response", response.data.Lite_Merchant_ApplicationID);
      
      // Actualizar `localFormData`, ya que `props.formData` no se puede modificar directamente
      this.formData.Lite_Merchant_ApplicationID = response.data.Lite_Merchant_ApplicationID;
      this.formData.Ecom_ConsumerOrderID = response.data.reference_wsb;

      this.redirigirPorPost();
      
      
    } else {
      console.error("Error en la respuesta del backend");
    } 
      
    },
  sendHeight() {
        const height = Number(document.body.scrollHeight) + 140;
        window.parent.postMessage({ iframeHeight: height }, "*");
      }
 },

  async mounted() {

    var maintenance = await common.checkMaintenanceLS("nedbank");
    
    if (maintenance) {
      this.$router.push({ name: 'DepositMaintenanceLesotho' , query: { username: this.$route.query.username }  });
    }
    else{
      this.$router.push({ name: 'NedbankDepositWebsite' , query: { username: this.$route.query.username }  });
  }
    // Enviar altura inicial al cargarse el componente
    this.sendHeight();

    // También puedes agregar un listener para resize si lo deseas
    window.addEventListener("resize", this.sendHeight);
  },

  updated() {
    // Enviar altura después de que el DOM se actualice (por si hay cambios dinámicos)
    this.$nextTick(() => {
      this.sendHeight();
    });
  },

  beforeUnmount() {
    // Limpiar el listener si lo agregaste
    window.removeEventListener("resize", this.sendHeight);
  }
};
</script>

<style scoped>
.arrow-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 8px;
}

.btn-back {
  background-color: #f99f44;        /* Naranja suave */
  color: rgb(0, 0, 0);
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  /* font-weight: bold; */
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 20px;
}

.btn-back:hover {
  background-color: #f67d3c;        /* Naranja más fuerte en hover */
}
.amount-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 10px 0;
}
.amount-buttons button {
  background-color: #ff8800;
  color: rgb(0, 0, 0);
  border: none;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
}
.amount-buttons button:hover {
  background-color: #cc6b00;
}

.amount-buttons button:disabled {
 background-color: #ffaa66; /* más claro y menos saturado */
  color: #5a5a5a;
  cursor: not-allowed;
  opacity: 0.8;
}

body {
  background-color: #f0f0f0;
  font-family: Arial, sans-serif;
}

h1 {
  /* color: #000000;
  text-align: center;
  font-weight: 800;
  background-color: #ff8800; */
   color: #000;
    text-align: center;
    font-weight: 800;
    /* background-color: #f80; */
    padding: 15px;
}

p {
  color: #555;
  text-align: center;
}

p strong{
  color: #000000;
}

.contenedor {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
  display: inherit;
  background-color: #e7e7e7;
  align-content: center;
  justify-items: center;
}

input[type="number"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 0px;
  font-size: 16px;
  width: 100%;
}

.button {
  padding: 10px 20px;
  background-color: #dedede;
  color: rgb(0, 0, 0);
  border: 1px solid #ccc;
  border-radius: 0px;
  font-size: 16px;
}

.mensaje-error {
  margin-top: 6px;
  /* margin-right: 430px; */
  font-size: 12px;
  color: #cc371b;
}

.deposit {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  min-width: 275px;
  margin-top: 10px;
  padding: 10px 20px;
  cursor: pointer;
    color: black;
  background-color: #cddc39;
   border: 2px solid #cddc39;
  border-radius: 6px ; /* Borde redondeado */
  transition: background-color 0.3s ease;
}

.deposit:hover {
   border: 2px solid #0e9e29;
  background-color: #b7dc39;
}

.deposit:disabled {
  cursor: not-allowed;
  background-color: #ccc;
}

.finaltext {
  display: block;
}

.amount {
  width: 30%;
  min-width: 275px;
  display: flex;
  justify-content: center;
}

span {
  color: #505050;
  margin: auto;
}

/* Estilo para los mensajes de respuesta */
.response-message {
  margin-top: 20px;
  padding: 10px;
  text-align: center;
  border-radius: 5px;
  font-weight: bold;
}

.response-message.success {
  background-color: #d4edda;
  color: #155724;
}

.response-message.error {
  background-color: #f8d7da;
  color: #721c24;
}
</style>
